$('.menu-navbar__mobile-toggle').on('click', function (e) {
    $(this).children().toggleClass('is-on');
    $(this).siblings('.menu-navbar__container').toggleClass('is-visible');
    e.stopPropagation();
});

$('body').on('click', function() {
    $('.menu-navbar__mobile-toggle').children().removeClass('is-on');
    $('.menu-navbar__container').removeClass('is-visible');
});

$('.menu-navbar__container').on('click', function(e) {
    e.stopPropagation();
});

$('#env-switch__button').on('click', function () {
    var elButton = $(this);
    var elList = $('#env-switch__list');

    if (elList.attr('hidden')) {
        hideSwitch(elButton, elList);
    }
    else {
        showSwitch(elButton, elList);
    }
});

function hideSwitch(elButton, elList) {
    elList.removeAttr('hidden');
    elButton.attr('aria-expanded', 'true');
}

function showSwitch(elButton, elList) {
    elList.attr('hidden', 'true');
    elButton.attr('aria-expanded', 'false');
}